import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoginService } from '../../services/login.service';
import { LoggingService } from 'src/app/services/core/logging.service';
import { HttpService } from 'src/app/services/core/http.service';
import { PEDGE_ID_ROLE_LIST } from 'src/app/shared/constants/roles.constants';

/**
 * Landing do fluxo SAML: o Maestro (/v2/saml/acs) redireciona pra aqui com o
 * JWT no fragmento da URL depois de validar a resposta assinada da Atvos.
 * Sem JS no meio do caminho (o ACS é um POST direto da IdP pro Maestro) -- por
 * isso esse handoff via redirect, em vez de uma chamada de API convencional.
 * Ver brainstorm-sso-microsoft-atvos.md §3.10.
 */
@Component({
  selector: 'app-sso-callback',
  template: `
    <main class="sso-callback-loading">
      <mat-progress-spinner mode="indeterminate" diameter="40" color="accent" />
    </main>
  `,
  styles: [
    `
      .sso-callback-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner],
})
export class SsoCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private loginService = inject(LoginService);
  private logging = inject(LoggingService);
  private http = inject(HttpService);

  async ngOnInit() {
    const jwt = this.route.snapshot.queryParamMap.get('jwt');

    if (!jwt) {
      this.router.navigateByUrl('/login?sso_error=true');
      return;
    }

    try {
      await this.loginService.tokenLogin(jwt);

      // Mesma sequência de login.component.ts (sign_in/submitMfaCode): sem
      // isso, IS_OPERATOR_OR_SUPPORT_P2 nunca é gravado no localStorage e o
      // Electron (interface-new/index.js) fica esperando essa chave pra
      // sempre -- a /interface nunca abre pra operadores/suporte/gestor P2.
      const auth_user_data = await this.http.maestroUserGet('v2/pweb_auth');
      const isOperatorOrSupportP2 = PEDGE_ID_ROLE_LIST.includes(auth_user_data.id_role);
      this.loginService.setIsOperatorOrSupportP2(isOperatorOrSupportP2);
    } catch (error) {
      this.logging.logError('SsoCallbackComponent.ngOnInit', error);
      this.router.navigateByUrl('/login?sso_error=true');
    }
  }
}
